// import { useCallback } from 'react';

export default function Overlay({ onClose }) {
  return <div className="overlay" />;
}
